
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/Transitions",
      function () {
        return require("private-next-pages/Transitions.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/Transitions"])
      });
    }
  